import { render, staticRenderFns } from "./BusinessInsider.vue?vue&type=template&id=1fe35bda&"
import script from "./BusinessInsider.vue?vue&type=script&lang=js&"
export * from "./BusinessInsider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports